// Eğitim webinar içerikleri — Aysun Şeremet tarafından hazırlanmıştır
// Bu dosya statik içerik barındırır, Firestore gerekmez.

export const trainings = [
  {
    id: "ergenlik-surecini-anlamak",
    title: "Ergenlik Sürecini Anlamak Webinarı",
    subtitle: "Çocuğunuzun değişimini anlamlandırmanın yolu",
    description:
      "Ergenlik bir kopuş değil, dönüşümdür. Çocuğunuzun davranışlarını 'düzeltmek' yerine onları anlamlandırmanıza yardımcı olan bir program.",
    icon: "🌱",
    duration: "2 saat",
    audience: "Ebeveynler, öğretmenler, ergenlerle çalışan profesyoneller",
    content: `“Çocuğum değişti… ama neden?”

Bir sabah uyanıyorsunuz ve çocuğunuz artık eskisi gibi değil. Eskiden sizinle sohbet eden, her şeyi anlatan o çocuk; şimdi daha mesafeli, daha tepkili ve çoğu zaman daha kapalı. Söylediklerinize hemen karşı çıkıyor, kendi alanını daha fazla savunuyor ve sizi zaman zaman dışarıda bırakıyor gibi hissediyorsunuz. Bu değişim sizi şaşırtıyor olabilir. Hatta bazen 'Nerede hata yaptım?' diye düşünmenize bile neden olabilir.

Ama aslında olan şey çok daha doğal…

## Bu Bir Kopuş Değil, Dönüşüm

Ergenlik; çocuğunuzun sizden uzaklaştığı değil, kendine doğru yaklaştığı bir süreçtir. Bu dönemde genç birey:

• Kendi düşüncelerini oluşturur
• Kim olduğunu anlamaya çalışır
• Duygularını yoğun ve hızlı yaşar
• Bağımsızlık ihtiyacı hisseder

Yani gördüğünüz değişim, bir 'problem' değil; gelişimin bir parçasıdır.

## Neden Bu Kadar Zor Geliyor?

Çünkü bu süreç sadece çocuklar için değil, ebeveynler için de bir uyum sürecidir. Bir yandan çocuğunuzu korumak istersiniz, diğer yandan onun kendi ayakları üzerinde durmasını… Bir yandan sınır koymak istersiniz, diğer yandan onu kaybetmekten korkarsınız. Tam da bu yüzden birçok ebeveyn şu ikilemi yaşar 'ne kadar yakın olmalıyım, ne kadar geri çekilmeliyim?'

## Aslında Olan Ne?

Toplumda ergenlik çoğu zaman;

• Asi
• Duygusal olarak dengesiz
• Kontrol edilmesi gereken bir dönem olarak görülür.

Oysa gerçek çok daha farklıdır. Ergenlik:

✨ Beynin yeniden yapılandığı
✨ Öğrenme kapasitesinin arttığı
✨ Yaratıcılığın ve cesaretin geliştiği
✨ Kimlik oluşumunun temellerinin atıldığı son derece kritik bir yaşam evresidir.

## Bu Programda Ne Kazanacaksınız?

Bu eğitim, çocuğunuzun davranışlarını 'düzeltmekten' çok, onları anlamlandırmanıza yardımcı olur. Program boyunca:

• Davranışların arkasındaki gerçek ihtiyaçları fark edeceksiniz
• Çocuğunuzla kurduğunuz iletişimi yeniden şekillendireceksiniz
• Çatışma anlarını daha sağlıklı yönetmeyi öğreneceksiniz
• Sınır koyarken ilişkiyi koruyabilmenin yollarını keşfedeceksiniz
• Onun bireyselleşme sürecine nasıl destek olabileceğinizi anlayacaksınız

## Kimler Katılmalı?

• Çocuğundaki değişimleri anlamakta zorlanan ebeveynler
• İletişimde kopukluk yaşayanlar
• Sürekli çatışma yaşayan aileler
• Daha bilinçli ve dengeli bir ebeveynlik yaklaşımı geliştirmek isteyenler
• Ergenlerle çalışan profesyoneller

## Bu Süreçte Yalnız Değilsiniz

Ergenlik, çoğu zaman zorlayıcıdır… ama doğru yaklaşımla bağı güçlendiren bir döneme dönüşebilir. Bu programın amacı; çocuğunuzu değiştirmek değil, onun dünyasını daha net görebilmenizi sağlamak. Çünkü anlaşılan her genç, daha sağlıklı bir yetişkine dönüşür.`,
  },
  {
    id: "bezden-tuvalete-saglikli-aliskanliklar",
    title: "Bezden Tuvalete: Sağlıklı Tuvalet Alışkanlıkları Webinarı",
    subtitle: "Çocuğunuzla birlikte sakin bir geçiş süreci",
    description:
      "Tuvalet alışkanlığı sadece bir beceri değil, çocuğun gelişiminde önemli bir dönüm noktasıdır. Süreci zorlaştıran kalıplardan çıkıp sağlıklı bir yol haritası.",
    icon: "🌼",
    duration: "2 saat",
    audience: "Tuvalet alışkanlığı sürecindeki ebeveynler",
    content: `Çocuğunuz hazır mı? Yoksa siz mi hazır olmak istiyorsunuz?

Çocuğunuzun bezden çıkmasını istiyorsunuz ama içinizde bazı sorular var:

• 'Acaba doğru zaman mı?'
• 'Hazır olduğunu nasıl anlarım?'
• 'Yanlış yaparsam süreci zorlaştırır mıyım?'
• 'Tuvalete gitmek istemezse ne yapacağım?'

Bu sorular çok tanıdık. Çünkü tuvalet alışkanlığı, sadece bir beceri değil, çocuğun gelişiminde önemli bir dönüm noktasıdır.

## Bu Süreç Aslında Neyi İfade Eder?

Tuvalet alışkanlığı kazanmak; çocuğun yalnızca fiziksel bir beceri edinmesi değil…

• Kendi bedenini tanımaya başlamasıdır
• Kontrol duygusunun gelişmesidir
• Bağımsızlık sinyallerinin ortaya çıkmasıdır

Bu yüzden süreç sadece 'öğretmek' değil, eşlik etmek ile ilgilidir.

## Neden Bazı Süreçler Zor Geçer?

Bazı çocuklar kolay adapte olurken, bazıları zorlanabilir.

• Tuvalete gitmek istememe
• Sürekli erteleme
• Kazalar yaşanması
• Direnç ve inatlaşma

Bunlar çoğu zaman bir problem değil, çocuğun verdiği mesajlardır. Önemli olan bu davranışların arkasındaki ihtiyacı görebilmektir.

## Temel Nokta: Beden Farkındalığı

Sağlıklı bir tuvalet alışkanlığının temeli, çocuğun kendi bedenini fark edebilmesidir. Çocuk:

• Ne zaman ihtiyacı olduğunu hissedebilmeli
• Bu sinyali anlayabilmeli
• Ve bunu ifade edebilmelidir

Bu beceri gelişmeden yapılan her zorlama, süreci uzatabilir ve zorlaştırabilir.

## Bu Eğitimde Neleri Öğreneceksiniz?

Bu programda, süreci zorlaştıran kalıplardan çıkıp daha sağlıklı bir yol haritası oluşturmanızı hedefliyoruz:

✨ Çocuğunuzun hazır olup olmadığını nasıl anlarsınız?
✨ Tuvalet alışkanlığına geçişi nasıl başlatmalısınız?
✨ Süreci adım adım nasıl ilerletebilirsiniz?
✨ Direnç gösterdiğinde nasıl yaklaşmalısınız?
✨ Kazalar karşısında ne yapmalı, ne yapmamalısınız?
✨ Bu süreci çocuğunuz için nasıl güvenli ve rahat hale getirirsiniz?

## Kimler İçin Uygun?

• Çocuğunu bezden çıkarmayı planlayan ebeveynler
• Sürece başlamış ama zorlananlar
• Tuvalet alışkanlığı sürecinde kararsızlık yaşayanlar
• Daha bilinçli ve sağlıklı bir yaklaşım geliştirmek isteyenler

## Yaklaşımımız

Bu eğitimde amacımız:

❌ Zorlamak değil
❌ Baskı kurmak değil
✔ Çocuğun gelişim ritmine uyum sağlamak
✔ Onunla iş birliği kurmak
✔ Süreci daha sakin ve sağlıklı yönetmek

## Sonuç Olarak…

Tuvalet alışkanlığı bir 'eğitim' değil, bir geçiş sürecidir. Doğru yaklaşımla bu süreç; stresli bir mücadeleye değil, çocuğunuzla kurduğunuz güvenli bir iş birliğine dönüşür.`,
  },
  {
    id: "ebeveynlikte-ofke",
    title: "Ebeveynlikte Öfke: Kontrol Kaybından Farkındalığa Webinarı",
    subtitle: "Öfke duygusuyla daha sağlıklı bir ilişki",
    description:
      "Ebeveynlikte öfke duygusunu hissetmek hepimizin gerçeği. Pratikler, stratejiler ve somut adımlarla öfkeye farklı bir bakış açısı.",
    icon: "🔥",
    duration: "2 saat",
    audience: "Ebeveynler, uzmanlar, öğretmenler ve öfke ile başa çıkmakta zorlananlar",
    content: `• Her şey çok mu üst üste geliyor bu günlerde?
• Öfkeyi bastırarak küsmeye gitmek ya da kırgınlıkla duyguyu dışarıya vurma arasında gidip geliyor musunuz?
• Ya da dişimi sıkıyorum sıkıyorum, sonunda patlıyorum dediğiniz yerde misiniz?

Ebeveynlikte öfke duygusunu hissetmek hepimizin gerçeği. Tam uyku düzenini oturttum dediğiniz yerde çocuğunuzun hastalanması, tam okula alıştı dediğiniz yerde tatilin başlaması, bekleyen işler, desteksizlik, sürekli ertelediğiniz planlar…

"Bir çocuk büyütmek için bir köy gerekir" sözü ne kadar geçerli ise bu dönemde köylere sahip olmadığımız ve zaman zaman kendimizi çaresiz veya köşeye sıkışmış hissetme duygumuz da bir o kadar gerçek. Yaşamda sıradan görünen bir anın, sinir sistemimize fazla gelmesi ya da bizi tetiklemesi sonrasında aslında hiç benzemek istemediğimiz birine dönüşmek ve belki o sıradaki davranışlarımıza dair hissettiğimiz utanç ve suçluluk duygusu… Tüm bunlar yaşamın parçaları.

Mükemmel ebeveynlik diye bir efsane var ancak gerçek şu ki hepimiz elimizden gelenin en iyisini yapıyoruz. Yalnız değilsiniz, kötü bir ebeveyn de değilsiniz. Çocuğunuz ya da siz problemli değilsiniz. Hepimiz bazen zor zamanlardan geçiyoruz.

## Webinar Hedefi

'Öfke ile Baş Edebilmek' webinarıyla amacımız sizi pratikler, stratejiler, somut adımlarla desteklemek ve öfke duygusuna kendinize veya çocuğunuza yönelik ihtiyaç duyabileceğiniz farklı bir bakış açısı getirebilmek.

## Eğer siz de;

• Son zamanlarda ebeveynliğin keyifli yanlarından çok öfke duygusu ile mücadele ediyorsanız,
• Kontrolü sık sık kaybettiğinizi hissediyorsanız,
• Bazen öfkeyi bastırmak için darılma ya da küsme yollarını tercih ediyor ya da ilişkinizi kesiyorsanız,
• Öfke duygusunu tutmaktan yorulduysanız,
• Öfke duygusunu nasıl dönüştürebileceğinize dair fikirlere ihtiyaç duyuyorsanız

'Öfke ile Baş Edebilmek' webinarında buluşalım.

## Webinar Kimler İçin Uygundur?

Webinar ebeveynler, uzmanlar, öğretmenler ve öfke duygusu ile başa çıkmakta zorlanan herkese açıktır.

Webinar süresi iki saattir.`,
  },
  {
    id: "okula-uyum-ve-adaptasyon",
    title: "Okula Uyum ve Adaptasyon Webinarı",
    subtitle: "İlk büyük ayrışma deneyimine birlikte eşlik",
    description:
      "Ayrılmak zor ama doğru destekle mümkün. Okula uyum sürecinin duygusal tarafını anlamanıza yardım eden kapsamlı bir rehber.",
    icon: "🎒",
    duration: "2 saat",
    audience: "Kreş, anaokulu ve ilkokula geçiş yapan çocukların aileleri",
    content: `Ayrılmak zor ama doğru destekle mümkün. Yaz boyunca birlikteydiniz. Aynı evde, aynı ritimde, çoğu zaman yan yana…

Şimdi ise yeni bir dönem başlıyor. Ve bu sadece bir okul başlangıcı değil. Çocuğunuz için sizden ilk gerçek ayrışma deneyimlerinden biri. Peki siz hazır mısınız? Ya çocuğunuz?

## Bu Süreç Neden Bu Kadar Önemli?

Okula başlamak, çocuk için sadece yeni bir ortam değil;

• Yeni insanlar
• Yeni kurallar
• Yeni bir düzen
• Ve en önemlisi, sizden ayrı bir alan.

Bu nedenle bazı çocuklar için bu süreç;

• Kaygı
• Ağlama
• Okula gitmek istememe
• Öfke ya da içe kapanma

gibi tepkilerle kendini gösterebilir. Bu tepkiler 'problem' değil, uyum sürecinin doğal parçalarıdır.

## Ebeveyn Olarak En Büyük Zorluk Ne?

Çoğu ebeveyn burada iki duygu arasında kalır;

• 'Onu bırakmak istemiyorum'
• 'Ama güçlü olması gerekiyor'

Ve bazen fark etmeden şu olur; çocuğun kaygısını yatıştırmaya çalışırken kendi kaygımız devreye girer. Oysa çocuklar en çok şuna ihtiyaç duyar; sakin ve güven veren bir ebeveyne.

## Bu Eğitimde Neye Odaklanıyoruz?

Bu programda sadece okula alışmayı değil, bu sürecin duygusal tarafını anlamayı hedefliyoruz. Birlikte şu sorulara cevap bulacağız;

• Çocuğum okulda kendini güvende hissetmesi için neye ihtiyaç duyar?
• Ayrılık anlarını daha sağlıklı nasıl yönetebilirim?
• Sabah bırakırken ağladığında nasıl davranmalıyım?
• Okuldan sonra yaşanan duygusal boşalmalar normal mi?
• Çocuğum okula gitmek istemediğinde ne yapmalıyım?
• Kendi kaygımı çocuğuma yansıtmadan nasıl süreci yönetebilirim?

## Somut Örneklerle İlerliyoruz

Bu eğitimde sadece teori yok. Günlük hayatta en çok karşılaşılan durumları birlikte ele alıyoruz;

• Kapıda ağlayan çocuk
• 'Okula gitmeyeceğim' diyen sabahlar
• Öğretmene yapışan ya da sınıfa girmek istemeyen çocuk
• Eve geldiğinde öfke patlaması yaşayan çocuk

Bu anlarda ne söylemeli, ne yapmalı, nerede durmalısınız? Hepsini adım adım konuşuyoruz.

## Hazırlık Süreci Neden Kritik?

Okula uyum sadece ilk günle ilgili değildir. Asıl belirleyici olan;

📌 Okuldan önceki haftalar
📌 Evde kurulan rutinler
📌 Yapılan küçük hazırlıklardır

Doğru hazırlık, sürecin yarısını kolaylaştırır.

## Kimler İçin Uygun?

• Kreşe veya anaokuluna başlayacak çocukların ebeveynleri
• İlkokula geçiş sürecinde olan aileler
• Ayrılık kaygısı yaşayan çocukların ebeveynleri
• Okula alışma sürecinde zorlananlar

## Bu Eğitimin Amacı

❌ Çocuğu zorlamak değil
❌ 'Alışır, gönder gitsin' demek değil
✔ Süreci anlamak
✔ Duygusal ihtiyaçları görmek
✔ Güvenli bir geçiş sağlamak

Unutmayın; okula başlamak, çocuğun hayatındaki ilk büyük 'ayrılma' deneyimlerinden biridir. Ve bu deneyim…

• Ya bir kırılma olur
• Ya da güven duygusunun temeli

Nasıl ilerleyeceğini ise büyük ölçüde sizin yaklaşımınız belirler.`,
  },
  {
    id: "cocugumun-buyuk-duygulari",
    title: "Çocuğumun Büyük Duygularına Nasıl Eşlik Edebilirim? Webinarı",
    subtitle: "Yoğun duygular yaşayan çocuklara destek olma",
    description:
      "Bazı çocuklar duygularını daha yoğun yaşar. Krizlere sakin, güvenli ve düzenleyici bir eşlikçi olmanın yolları.",
    icon: "💗",
    duration: "2 saat",
    audience: "Okul öncesi ve ilkokul çocuklarının ebeveynleri, uzmanlar",
    content: `Yoğun duygular yaşayan çocuklara nasıl destek oluruz?

Bazı çocuklar duygularını daha yoğun yaşar. Üzülünce çok üzülür, öfkelenince hızla yükselir, hayal kırıklığı yaşadığında toparlanması uzun sürebilir. Belki siz de zaman zaman şöyle hissediyorsunuz;

• Küçük bir şey bile onda büyük bir fırtınaya dönüşüyor.
• Bir anda çok yükseliyor, ne yapacağımı şaşırıyorum.
• Yanına gidip destek olmak istiyorum ama beni de istemiyor gibi oluyor.
• Sakinleştirmeye çalıştıkça daha da zorlanıyor.
• Kriz anları çok uzuyor, hem o hem ben tükeniyoruz.

Eğer bunlar size tanıdık geliyorsa, yalnız değilsiniz.

## Önce Şunu Bilmek Gerekir

Çocuğunuzun duygularının yoğun olması, onun problemli olduğu anlamına gelmez. Aynı şekilde sizin zorlanıyor olmanız da yanlış ebeveynlik yaptığınız anlamına gelmez.

Bazı çocukların sinir sistemi çevreden gelen uyarıları daha derin işler. Bu nedenle geçişler, hayal kırıklıkları, beklemek, engellenmek, yanlış anlaşılmak ya da yorgunluk gibi durumlar onlar için daha sarsıcı olabilir.

## Duygu Düzenleme Nasıl Gelişir?

Çocuklar duygularını tek başına kontrol etmeyi bir günde öğrenmez. Bu beceri, zor anların içinden geçerek ve bir yetişkinin desteğiyle zamanla gelişir.

Yani çocuğunuz zorlandığında, asıl ihtiyaç çoğu zaman hemen susturulmak ya da hızlıca düzeltilmek değildir. İhtiyaç duyduğu şey çoğu zaman şudur;

• Güvende hissetmek
• Anlaşıldığını deneyimlemek
• O anı tek başına taşımamak

## Günlük Hayattan Bildiğimiz Anlar

Bu durumlar çoğu aileye tanıdık gelir;

• Markette istediği bir şey olmayınca dağılan çocuk
• Oyunu bitince öfkeyle tepki veren çocuk
• Kardeşiyle yaşadığı küçük bir anlaşmazlıkta hızla taşan çocuk
• Okuldan döndüğünde en ufak şeyde ağlamaya başlayan çocuk
• Yorgunken, açken ya da üst üste fazla uyarana maruz kaldığında toparlanamayan çocuk

Dışarıdan abartı gibi görünen bu anlar, çocuğun iç dünyasında gerçekten büyük yaşanıyor olabilir.

## Bu Tür Anlarda En Sık Yapılan Şey

Çok doğal olarak çoğumuz hemen çözüm bulmaya çalışırız;

• "Tamam, ağlama"
• "Bu kadar büyütme"
• "Bir şey yok"
• "Sakin ol artık"

Ama yoğun duygular yaşayan çocuklar için bu sözler bazen rahatlatıcı olmak yerine yalnızlaştırıcı olabilir. Çünkü o anda çocuk, duygusunun küçümsenmediğini ve yanında bir yetişkin olduğunu hissetmeye ihtiyaç duyar.

## Asıl Destek Nedir?

Duygu düzenleme, duyguyu ortadan kaldırmak değildir. Zor duygunun içinde kalabilme kapasitesidir. Çocuk o an dağılmışken bizim sakinliğimiz, onun ödünç alabileceği bir denge haline gelir. Yani bazen çocuğu hemen susturmak değil, onun fırtınasına dayanıklı bir liman olmak gerekir.

## Bu Eğitimde Neleri Konuşacağız?

✨ Duygularını düzenlemekte zorlanan çocukların ortak özellikleri
✨ Kriz anlarında çocuğun içinde neler olup bittiği
✨ Utanç, suçluluk, öfke ve yoğun hassasiyet gibi duyguların çocukta nasıl göründüğü
✨ Tetiklenmelerin neden oluştuğu ve nasıl önceden fark edilebileceği
✨ Zor anlarda çocuğa nasıl eşlik edebileceğiniz
✨ Günlük yaşamda uygulanabilecek somut düzenleme stratejileri
✨ Ebeveyn olarak kendi duygularınızı nasıl koruyabileceğiniz

## Bu Eğitim Kimler İçin Uygun?

• Çocuğunun öfke, ağlama ya da kriz anlarında zorlandığını gören ebeveynler
• Hassas ve yoğun duygular yaşayan çocuklara daha iyi destek olmak isteyenler
• "Ne yapsam işe yaramıyor" hissi yaşayan aileler
• Okul öncesi ve ilkokul dönemindeki çocukların ebeveynleri
• Bu yaş grubuyla çalışan uzmanlar

## Bu Eğitimde Amacımız

❌ Çocuğu bastırmak değil
❌ Duyguyu susturmak değil
❌ Her krizi anında bitirmek değil
✔ Çocuğun duygusal dünyasını anlamak
✔ Zor anlara daha hazırlıklı yaklaşmak
✔ Hem çocuk hem ebeveyn için daha güvenli bir ilişki alanı kurmak

Yoğun duygular yaşayan çocukların daha fazla kontrole değil, daha fazla anlaşılmaya, düzenlenmeye ve birlikte taşınmaya ihtiyacı vardır. Ve çoğu zaman çocukların sakinleşmesi, önce bizim onlara nasıl eşlik ettiğimizle başlar.`,
  },
  {
    id: "anksiyete-caginda-yasamak",
    title: "Anksiyete Çağında Yaşamak Webinarı",
    subtitle: "Kaygıyla daha esnek bir ilişki kurmak",
    description:
      "Kaygı, stres ve belirsizlikle daha sağlıklı baş etmek mümkün. Bedensel ve zihinsel olarak daha sağlam hissetmenin pratik yolları.",
    icon: "🌊",
    duration: "2 saat",
    audience: "Kaygı, stres ve belirsizlikle baş etmek isteyen yetişkinler",
    content: `Kaygı, stres ve belirsizlikle daha sağlıklı baş etmek mümkün.

Son zamanlarda zihninizin hiç durmadığını mı hissediyorsunuz? Bir şeyler yolunda gitse bile içinizde hep yeni bir endişe mi beliriyor? Geleceği düşününce daralıyor, belirsizlik karşısında çabuk yoruluyor, gün içinde kendinizi gergin, dağınık ya da tükenmiş mi buluyorsunuz?

Böyle hissediyorsanız yalnız değilsiniz. Bugün pek çok insan; yoğun tempo, belirsizlik, ekonomik baskılar, gelecek kaygısı, ilişkisel yükler ve hayatın sürekli değişen akışı içinde zihinsel olarak yoruluyor. Kaygı, stres ve içsel baskı hali artık birçok kişi için günlük yaşamın bir parçasına dönüşmüş durumda.

## Kaygıyı Tamamen Yok Etmek Mümkün mü?

Her zaman değil. Ama kaygıyla kurduğumuz ilişkiyi değiştirmek mümkündür.

Çoğu zaman bizi en çok zorlayan şey yalnızca yaşadığımız duygu değil; o duyguyla karşılaştığımızda ne yaptığımız, onu nasıl yorumladığımız ve ne kadar yalnız hissettiğimizdir.

Kaygıyı hemen ortadan kaldırmaya çalıştıkça bazen daha da sıkışabiliriz. Oysa duygularla daha esnek bir ilişki kurmak, dayanıklılığımızı artırmanın önemli bir parçasıdır.

## Bu Eğitimde Neye Odaklanıyoruz?

Bu webinar, kaygıyı 'yok edilmesi gereken bir düşman' gibi görmek yerine, onu anlamayı, bedenimizde ve zihnimizde nasıl çalıştığını fark etmeyi ve onunla daha işlevsel bir ilişki kurmayı hedefler.

Amacımız;

• Kaygı ve stresin sizi ele geçirdiği anları daha iyi anlamak
• Bedeninizin verdiği sinyalleri tanımak
• Zor zamanlarda kullanabileceğiniz içsel ve dışsal kaynakları keşfetmek
• Günlük yaşamda uygulanabilir baş etme yolları geliştirmek

## Belki Siz de Şu Noktalardan Birindesiniz

• Kaygı ve stres son zamanlarda günlük yaşamınızı daha fazla etkiliyor
• Endişelerinizi yönetmekte zorlanıyorsunuz
• Zihniniz sürekli en kötü ihtimallere gidiyor
• Bedensel olarak da gerginlik, sıkışma, huzursuzluk yaşıyorsunuz
• Kendinizi desteklemek için yeni ve daha etkili yollar arıyorsunuz
• Sadece dayanmaya değil, gerçekten güçlenmeye ihtiyaç duyuyorsunuz

Eğer bunlardan birkaçı bile size tanıdık geliyorsa, bu eğitim size iyi gelebilir.

## Webinarda Neleri Ele Alacağız?

✨ Kaygı, stres ve yoğun endişe hali tam olarak nedir?
✨ Bu duygular bedenimizde nasıl ortaya çıkar?
✨ Zorlandığımız anlarda hangi kaynaklara tutunabiliriz?
✨ Kaygıyla baş ederken hangi stratejiler gerçekten işe yarar?
✨ Günlük yaşam içinde uygulanabilecek pratik destek yolları nelerdir?
✨ Zihinsel ve bedensel olarak kendimizi nasıl daha sağlam hissedebiliriz?

## Günlük Hayattan Tanıdık Haller

• Gece yatağa yattığınızda zihninizin susmaması
• En küçük belirsizlikte içinizin daralması
• Her ihtimali düşünmekten dinlenememek
• Sürekli güçlü kalmaya çalışmaktan yorulmak
• Gün içinde bedeninizin alarm halinde olması…

Bu anlarda neler yaşadığınızı anlamak, kendinize daha doğru yerden yaklaşabilmenin ilk adımıdır.

## Bu Webinar Kimler İçin Uygun?

• Kaygı ve stresle daha sağlıklı baş etmek isteyen yetişkinler
• Belirsizlik karşısında zorlananlar
• Kendini zihinsel ve bedensel olarak yorgun hissedenler
• Günlük yaşamda kullanabileceği pratik beceriler arayanlar
• Duygusal dayanıklılığını güçlendirmek isteyen herkes

## Bu Eğitimden Ne Kazanacaksınız?

✔ Kaygıyı daha iyi anlamanız
✔ Kendi işleyişinizi fark etmeniz
✔ Bedensel ve zihinsel sinyalleri tanıyabilmeniz
✔ Zor zamanlarda kullanabileceğiniz somut yöntemlerle ayrılmanız.

Kaygı yaşamak, zayıf olduğunuz anlamına gelmez. Zorlanıyor olmanız da yetersiz olduğunuzu göstermez. Bazen sadece, hayatın yükünü uzun süredir çok sessiz taşıyor olabilirsiniz. Bu webinar, o yükü biraz daha anlaşılır, biraz daha yönetilebilir hale getirmek için hazırlandı.`,
  },
  {
    id: "dikkat-ve-duzenleme-gucluklerinde-bag",
    title:
      "Dikkatini Toplamakta ve Kendini Düzenlemekte Zorlanan Çocuklarla Bağ Kurmak Webinarı",
    subtitle: "Utanç üretmeyen, destekleyici bir aile dili",
    description:
      "Farklı işleyen sinir sistemiyle dünyada yol bulmaya çalışan çocukların ebeveynlerine ve uzmanlara yönelik kapsamlı bir çalışma.",
    icon: "🧭",
    duration: "2 saat",
    audience: "Her yaş grubunda çocuğu olan ebeveynler, öğretmenler, uzmanlar",
    content: `Bazı çocuklar gün içinde sanki aynı anda birçok şeye yetişmeye çalışıyor gibidir. Bir şeyi duyar ama sonuna kadar sürdüremez, bir göreve başlar ama başka bir uyaranla hızla yön değiştirir, istemediği halde unutkan görünür, düşünmeden hareket eder, beklemekte zorlanır. Evde bu durum çoğu zaman şöyle cümlelere dönüşür;

• "Daha demin konuşmuştuk, yine aklından uçup gitmiş."
• "Bir işi bitirmeden öbürüne geçiyor."
• "Yerinde duramıyor, sürekli hareket halinde."
• "Sanki bizi dinlemiyor gibi."
• "İstese yapar diye düşünüyorum ama olmuyor."

Oysa bu tablo her zaman isteksizlik, saygısızlık ya da sorumsuzluk anlamına gelmez. Bazen çocuk, yapması bekleneni bildiği halde, o anda onu hayata geçirmek için gerekli iç düzenlemeyi kurmakta zorlanıyordur.

Çocukların sık sık eleştirilmesi, karşılaştırılması ya da "neden daha dikkatli olamıyorsun?" gibi ifadelerle karşılaşması, zaman içinde onların kendileriyle ilgili olumsuz bir hikaye yazmasına neden olabilir. Bir süre sonra çocuk sadece bir görevi değil, kendine dair güvenini de kaybetmeye başlayabilir.

## Bu Eğitimde Neye Odaklanıyoruz?

Dikkat ve hareket düzenleme alanında güçlük yaşayan çocukları "problem çıkaran" ya da "zor çocuk" olarak değil, farklı işleyen bir sinir sistemiyle dünyada yol bulmaya çalışan çocuklar olarak ele alıyoruz. Çünkü birçok çocuk daha iyisini umursamadığı için değil, o anda elindeki beceriler henüz yetmediği için zorlanır.

Bu nedenle bu webinarın odağında tanı koymak değil; günlük yaşamda çocuğunuzla daha sağlıklı bir bağ kurmak, çatışmayı azaltmak ve ev içindeki dili dönüştürmek var.

Her gün "yapamıyorsun", "dinlemiyorsun", "hep aynı şey" mesajını alan bir çocuk, gerçekten kendini toparlayacak iç gücü nereden bulacak?

Bu eğitimde çocukların zorlandıkları alanları anlamayı, utancı artırmadan nasıl destek olabileceğimizi ve evde daha güvenli bir ilişki iklimini nasıl kurabileceğimizi konuşacağız.

## Günlük Hayattan Çok Tanıdık Anlar

• Sabah hazırlanırken her şeyin uzaması
• Defterini, matarayı, ödevini tekrar tekrar unutması
• Bir anda yükselip öfkeye geçmesi
• Hayır cevabını tolere edememesi
• Kardeş ilişkilerinde çabuk taşması
• Sürekli uyarı alan çocuk ile yorgun düşen ebeveyn döngüsü…

Bu anlarda ne olduğunu anlamak, çoğu zaman çözümün ilk adımıdır.

## Webinarda Ele Alacağımız Başlıklar

• Dikkat ve hareket düzenleme güçlüğü günlük yaşamda nasıl görünür?
• Bu alanda zorlanan bir çocuğun ebeveyni olmak ne anlama gelir?
• Evde en sık zorlanılan alanlar nelerdir?
• Çocuğun benlik algısını zedelemeden nasıl sınır koyabiliriz?
• Utanç üretmeyen, destekleyici bir aile dili nasıl kurulur?
• Duygu düzenleme becerileri çocuğa nasıl eşlik edilerek gelişir?
• Öfke anlarında, krizlerde ve taşma durumlarında nasıl yaklaşmak gerekir?

## Kimler İçin Uygun?

• Her yaş grubunda çocuğu olan ebeveynler
• Öğretmenler
• Psikologlar ve çocuklarla çalışan uzmanlar

Çünkü yaş değişse de, çocukla kurulan ilişkinin temel ilkeleri benzerdir; anlamak, düzenlemek, ilişkiyi korumak ve çocuğun kendilik değerini zedelemeden destek olmak.

## Önemli Not

Bu webinar tanı ya da tedavi amacı taşımaz. Tanı ve klinik değerlendirme gereken durumlar için çocuk ve ergen psikiyatrisi uzmanlarına başvurulmalıdır.

Bu eğitim, çocuğunuzla daha az çatıştığınız, onu daha iyi anladığınız ve kendinizi de daha donanımlı hissettiğiniz bir aile dili kurmanız için hazırlandı.`,
  },
  {
    id: "iliskilerde-saglikli-sinirlar",
    title: "İlişkiler Buluşması: İlişkilerde Sağlıklı Sınırlar",
    subtitle: "Kendini kaybetmeden var olmanın yolları",
    description:
      "Sınır koymak uzaklaştırmak değil, ilişkileri sürdürülebilir kılmaktır. Hayır demenin, kendini ifade etmenin pratik bir atölyesi.",
    icon: "🪷",
    duration: "2 saat",
    audience: "İlişkilerinde kendini daha net ifade etmek isteyen yetişkinler",
    content: `Sınır koymak sizin için zor mu?

• "Hayır" dediğinizde karşınızdaki kişinin kırılmasından çekiniyor musunuz?
• Çoğu zaman kendi ihtiyaçlarınızı ertelediğinizi fark ediyor musunuz?
• Sınır koyduğunuzda suçluluk hissi devreye giriyor mu?
• İlişkilerde kendinizi geri planda bıraktığınız oluyor mu?

Birçok insan için sınır koymak sadece bir davranış değil, aynı zamanda duygusal olarak zorlayıcı bir deneyimdir.

Sınırlar; karşımızdakini uzaklaştırmak için değil, ilişkileri daha sağlıklı ve sürdürülebilir hale getirmek için vardır. Sınır koymak, birini değiştirmeye çalışmak değildir. Kendi alanımızı, ihtiyaçlarımızı ve sınırlarımızı tanımlayabilmektir. Kendi sınırlarını fark edebilen kişi, hem kendisiyle hem de karşısındakiyle daha dengeli bir ilişki kurabilir.

## Sınırlar Neden Bu Kadar Zor?

Çoğu zaman sınır koymayı zorlaştıran şey, karşımızdakinin tepkisinden çok, içimizde oluşan duygulardır.

• Ya kırılırsa?
• Ya yanlış anlaşılırsa?
• Ya beni uzaklaştırırsa?

Bu düşünceler nedeniyle çoğu kişi ihtiyaçlarını dile getirmek yerine susmayı tercih eder. Ancak ifade edilmeyen ihtiyaçlar zamanla birikir. Ve bu birikim çoğu zaman; kırgınlık, öfke ve içe kapanma olarak ortaya çıkar.

## Günlük Hayattan Tanıdık Anlar

• İstemediğiniz bir şeyi sırf kırılmasın diye kabul etmek
• Yorgun olduğunuz halde problem çıkmasın diye hayır diyememek
• Sürekli anlayan taraf olmak ama anlaşılmadığını hissetmek
• İçten içe rahatsız olup dışarıda iyi görünmeye devam etmek…

Bu döngü sürdükçe kişi kendinden uzaklaşmaya başlar.

## Bu Buluşmada Neleri Ele Alacağız?

• Sınır nedir, sağlıklı sınır nasıl kurulur?
• Sınır koymayı zorlaştıran içsel kalıplar nelerdir?
• "Hayır" demek neden bu kadar zor gelir?
• Sınır koyarken oluşan suçluluk duygusu ile nasıl baş edilir?
• Karşı tarafın tepkisiyle nasıl kalabiliriz?
• İlişkilerde kendimizi kaybetmeden nasıl var olabiliriz?
• Duygular, öfke ve sınırlar arasındaki bağlantı nedir?

## Kimler İçin Uygun?

• İlişkilerinde kendini daha net ifade etmek isteyenler
• Sınır koymakta zorlananlar
• Sürekli "idare eden taraf" olduğunu hissedenler
• Kendi ihtiyaçlarını fark etmek ve ifade etmek isteyenler

## Bu Buluşmanın Amacı

❌ İnsanları değiştirmek değil
❌ İlişkileri kesmek değil
✔ Kendimizi daha iyi anlamak
✔ Kendi sınırlarımızı fark etmek
✔ İlişkilerde daha dengeli bir alan kurmak…

Sınır koymak, uzaklaşmak değildir. Tam tersine, ilişkiyi daha sağlıklı bir yerde tutabilmektir. Kendinizi ifade edebildiğiniz ilişkilerde, hem bağ hem de denge birlikte var olabilir.`,
  },
  {
    id: "cocuklarda-ozguven-ic-ses",
    title: "Çocuklarda Öz Güven ve İç Sesin Gelişimi Webinarı",
    subtitle: "Kendi sesini duyabilen çocuklar yetiştirmek",
    description:
      "Çocukların iç dünyasında sağlam bir kendilik duygusu geliştirmelerine destek olmanın yolları; öz güven bir öğütle değil, ilişkide oluşur.",
    icon: "✨",
    duration: "2 saat",
    audience: "Her yaş grubu çocuğun ebeveyni ve çocuklarla çalışan uzmanlar",
    content: `Çocukların kendilerine nasıl baktığı, büyük ölçüde onlarla nasıl ilişki kurduğumuzla şekillenir.

Çocuklar büyürken sadece söylediklerimizi değil, onlara nasıl baktığımızı, nasıl yaklaştığımızı ve zorlandıkları anlarda onlarla nasıl kaldığımızı da içselleştirirler. Bir çocuk, kendisiyle ilgili ilk fikirlerini çoğu zaman şu görünmez sorular üzerinden oluşturmaya başlar;

• "Ben değerli miyim?"
• "Olduğum halimle kabul ediliyor muyum?"
• "Yanlış yaptığımda sevgiyi kaybeder miyim?"
• "Benim de bir sesim, bir yerim var mı?"
• "Yeterli biri olabilir miyim?"

Bu soruların cevabı çoğu zaman doğrudan verilmez. Çocuk, bu cevapları bizimle kurduğu ilişkiden toplar.

## Öz Güven Nasıl Oluşur?

Öz güven sadece yüksek sesle konuşmak, girişken olmak ya da kalabalık ortamlarda rahat görünmek değildir. Öz güvenin temelinde, çocuğun kendi iç dünyasına dair geliştirdiği güven duygusu vardır. Yani çocuk öz güveni şöyle kurar;

• Duyguları görüldüğünde
• Çabası fark edildiğinde
• Hata yaptığında bütünüyle kötü hissettirilmediğinde
• Kendi temposuna alan açıldığında

Bir çocuk kendisini sürekli başkalarıyla kıyaslandığı, acele ettirildiği ya da 'neden daha farklı değilsin?' mesajını aldığı bir ortamda, içten içe yetersizlik duygusu geliştirebilir.

## Günlük Hayatta Sık Gördüğümüz Durumlar

Bazı çocuklar yeni bir ortama girmekte zorlanabilir. Bazıları arkadaşlık kurmak için daha fazla zamana ihtiyaç duyar. Bazıları kalabalık içinde geri planda kalır, bazıları denemeden önce uzun süre izler.

Bu anlarda ebeveynin zihninden hızla şu düşünceler geçebilir;

• "Acaba hep böyle mi kalacak?"
• "Kendini neden bu kadar geri çekiyor?"
• "Diğer çocuklar kadar rahat değil."
• "Kendi potansiyelini göremiyor."

Bu kaygılar çok insani. Ama çocuklar, kendileriyle ilgili inançlarını çoğu zaman bizim onlara verdiğimiz açık ya da örtük mesajlardan kurar.

## Çocuğun İç Sesi Nereden Gelir?

Bir çocuğun kendi kendine nasıl konuştuğu, çok büyük ölçüde yetişkinlerin onunla nasıl konuştuğuyla ilgilidir.

Eğer çocuk sık sık; eleştiriliyorsa, yetersiz hissettiriliyorsa, utandırılıyorsa, 'daha cesur ol', 'abartma', 'çekinme artık' gibi baskılar görüyorsa, zamanla kendi içinde de benzer bir ses oluşturmaya başlayabilir.

Ama destekleyici, kapsayıcı ve sabırlı bir ilişki içinde büyüyen çocuk, zamanla kendisine daha güvenli bir yerden yaklaşmayı öğrenir.

## Bu Eğitimde Neye Odaklanıyoruz?

Bu programda amacımız, çocukların öz güvenini dışarıdan yükseltmek değil; onların iç dünyasında daha sağlam bir kendilik duygusu gelişmesine nasıl destek olabileceğimizi birlikte anlamak.

✨ Çocuklarda öz güven ve öz değer nasıl gelişir?
✨ Çocuğun iç sesi nasıl oluşur?
✨ Çekingenlik, geri durma ve sosyal zorlanmalar nasıl anlaşılabilir?
✨ Olumsuz geri bildirimler çocukta nasıl bir iz bırakır?
✨ Çocuğun kendisini yetersiz hissettiği anlarda nasıl yaklaşılmalı?
✨ Ebeveyn olarak hangi tutumlar güven inşa eder, hangileri zedeler?
✨ Çocuğun kendi sesini bulmasına nasıl alan açabiliriz?

## Bu Eğitim Kimler İçin Uygun?

• Çocuğunun çekingen, geri duran ya da kendine güvenmekte zorlanan bir yapısı olduğunu düşünen ebeveynler
• Çocuğunda öz değer duygusunu desteklemek isteyen aileler
• 'Yeterince iyi değilim' gibi düşünceleri olan çocuklara nasıl yaklaşacağını bilemeyenler
• Çocuklarla çalışan uzmanlar

## Bu Eğitimde Amacımız

❌ Çocuğu daha sosyal görünmeye zorlamak değil
❌ Hızlı sonuçlar almak değil
❌ Dışarıdan güçlü görünmesini sağlamak değil
✔ İçeriden daha sağlam hissetmesine destek olmak
✔ Kendi değerini dış onaya bağlı kurmamasına yardımcı olmak
✔ Kendi sesini duyabilen bir çocuk yetiştirmek…

Öz güven, çocuğa verilen bir öğütle değil; yaşadığı ilişkilerin içinde yavaş yavaş oluşur. Bir çocuk, görüldüğünde, duyulduğunda ve olduğu haliyle kabul edildiğinde yalnızca daha rahat hissetmez; aynı zamanda kendi iç dünyasında daha güçlü bir temel kurar.`,
  },
  {
    id: "dijital-dunyada-ebeveyn-olmak",
    title: "Dijital Dünyada Ebeveyn Olmak: Çocuklarla Ekran Dengesi Kurmak Webinarı",
    subtitle: "Çocuğunuzla ekran arasında denge",
    description:
      "Ekranla ilişki çoğu zaman yüzeyde görünen kısımdır. Altında sınır koyma, duygusal dayanıklılık ve rutin meseleleri yatar.",
    icon: "📱",
    duration: "2 saat",
    audience: "Ebeveynler, çocuklarla çalışan uzmanlar",
    content: `Kendi çocukluğunuzu düşündüğünüzde aklınıza neler geliyor?

Sokakta geçirilen uzun saatler, arkadaşlarla oynanan oyunlar, belki de eve dönmek istemediğiniz akşamlar… Birçoğumuz için çocukluk; hareketin, temasın ve dış dünyanın iç içe geçtiği bir deneyimdi.

Bugünün çocukları ise bambaşka bir gerçeklikte büyüyor. Daha küçük yaşam alanları, daha sınırlı sosyal çevreler ve çoğu zaman dijital araçların yoğun olduğu bir dünya…

Bu yüzden bizim yaşadığımız çocukluk ile onlarınki arasında ciddi bir fark var. Ve bu farkı anlamadan çocukların ekranla kurduğu ilişkiyi değerlendirmek pek mümkün değil.

## Dijital Dünya: Kaçınılmaz Bir Gerçeklik

Günümüzde çocuklar; oyunları, sosyal ilişkileri, öğrenme süreçleri ve hatta eğlenceyi büyük ölçüde dijital ortamlar üzerinden deneyimliyor. Telefonlar, tabletler, bilgisayarlar ve televizyon artık sadece araç değil; çocukların hayatının aktif bir parçası.

Bu dünya oldukça çekici. Aynı zamanda çocuklar, arkadaş çevreleri ve sosyal ortamlar üzerinden bu dünyaya dahil olma baskısı da hissedebiliyorlar.

## Neden Bu Kadar Zor?

Ekranla ilgili sınır koymak çoğu ebeveyn için düşündüğünden daha zor bir süreçtir. Çünkü;

• Dijital içerikler çocukları güçlü şekilde çekiyor
• Sosyalleşmenin bir kısmı artık ekran üzerinden gerçekleşiyor
• Eğitim süreçleri bile dijital araçlarla iç içe geçmiş durumda…

Bunun yanında, günlük hayatın temposu içinde ekran bazen ebeveynler için de bir kolaylaştırıcı haline gelebiliyor. Yemek yedirirken, bir işi tamamlarken ya da kısa bir mola vermek isterken ekran hızlı bir çözüm gibi görünebiliyor. Ama bu durum zamanla alışkanlığa dönüşebiliyor.

## Ekranla İlişki Nasıl Şekillenir?

Çocuklar ekranla nasıl bir ilişki kuracaklarını büyük ölçüde ailelerinden öğrenirler. Yani mesele sadece çocuğun ne kadar süre ekran kullandığı değil; aynı zamanda evde ekranın nasıl bir yere sahip olduğudur. Kendinize şu soruları sormak iyi bir başlangıç olabilir;

• Evde ekran ne zaman devreye giriyor?
• Zor anlarda ekran bir kaçış aracı oluyor mu?
• Biz kendi ekran kullanımımızla nasıl bir model sunuyoruz?

Çünkü çocuklar söylenenleri değil, gördüklerini daha çok içselleştirirler.

## Sınır Koymak Neden Zor Gelir?

Birçok ebeveyn için sınır koymak sadece kurallarla ilgili değildir; duygusal olarak da zorlayıcıdır. Çünkü;

• Çocuğun üzülmesine dayanmak zor olabilir
• Ağlama ya da ısrar karşısında geri adım atmak kolaylaşır
• "Şimdi buna hayır demeli miyim?" kararsızlığı yaşanır

Bu yüzden ekran konusu çoğu zaman bir güç mücadelesine dönüşebilir.

## Aslında Mesele Sadece Ekran Değildir

Ekran meselesi çoğu zaman yüzeyde görünen kısımdır. Altında ise şunlar olabilir; sınır koymakta zorlanma, duygusal dayanıklılık, rutin oluşturamama ve ebeveynin kendi yorgunluğu…

Bu yüzden ekranla ilgili çözüm de sadece süre azaltmak değildir. Daha çok bir denge kurma meselesidir.

## Bu Çalışmada Neye Odaklanıyoruz?

✨ Ekran kullanımının çocuk üzerindeki etkileri
✨ Günlük hayatta uygulanabilir sınır koyma yolları
✨ Ekran süresini çatışmaya dönüştürmeden düzenlemek
✨ Dijital içeriklerle sağlıklı mesafe kurmak
✨ Aile içinde ekran kullanımına dair ortak bir dil oluşturmak
✨ Çocuğun ekranla olan bağını anlamak

## Kimler İçin Uygun?

• Çocuğuyla ekran konusunda sık sık çatışma yaşayan ebeveynler
• Sınır koymakta zorlandığını hissedenler
• Ekranı tamamen yasaklamak yerine denge kurmak isteyenler
• Çocuklarla çalışan uzmanlar

Dijital dünya artık hayatın bir parçası. Önemli olan çocukları bu dünyadan tamamen uzak tutmak değil; onlara bu dünyanın içinde nasıl duracaklarını öğretebilmek. Sınırlar, yasaklamak için değil; çocuğun kendini daha güvende hissetmesi için vardır. Ve bu sınırlar en çok da ilişkiden öğrenilir.`,
  },
  {
    id: "kendinle-iliskiyi-onarmak",
    title: "Kendinle İlişkiyi Onarmak: İçsel Şefkat, Sınırlar ve Öz Bakım",
    subtitle: "Kendine eşlik etmenin yeni yolları",
    description:
      "Bugünkü zorlanmaların kökleri çoğu zaman geçmiştedir. Kendine şefkat, sınırlar ve öz bakım üzerine derinlemesine bir çalışma.",
    icon: "🌿",
    duration: "2 saat",
    audience: "Kendisiyle daha şefkatli bir ilişki kurmak isteyen herkes",
    content: `İnsan yetişkin olduğunda yaşadığı birçok zorlanmanın kökleri bugünde değil, çok daha eskide saklıdır.

Bugün zor dediğimiz pek çok tepki, aslında bir zamanlar işe yarayan yolların izidir. Bir çocuk için uyum sağlamak, sevilmek ve kabul görmek hayatta kalmanın bir parçasıdır. Bu yüzden geçmişte geliştirdiğimiz davranışlar bir seçim değil, bir ihtiyaçtı.

## Bir Zamanlar İşe Yarayan, Bugün Zorlayan

Çocukken kendimize sormadan öğrendiğimiz şeyler vardır;

• Ne yaparsam sevilirim?
• Ne yaparsam sorun çıkarmam?
• Nasıl davranırsam güvende kalırım?

Ve bu sorulara verdiğimiz cevaplar, zamanla karakterimiz gibi hissettiren alışkanlıklara dönüşür. Belki fazla uyum sağladık, belki kendimizi geri çektik, belki duygularımızı bastırmayı öğrendik.

O an için gerekliydi. Ama bugün aynı yollar bizi zorlayabiliyor.

## Kendimizi Geriye Çektiğimiz Yerler

Geçmişte eleştirildiğimiz, reddedildiğimiz ya da anlaşılmadığımız anlar içimizde iz bırakır. Bazen; hassasiyetimizi gizlemeyi, ihtiyaçlarımızı bastırmayı, görünmemeyi tercih etmeyi öğrenmiş olabiliriz. Çünkü görünmek riskli hissettirmiştir.

Zamanla şöyle bir inanç yerleşir; "bu halimle kabul edilmem, değişmem gerekiyor."

## İçimizdeki Parçalarla Yeniden Tanışmak

Oysa bugün geldiğimiz noktada şunu fark etmek mümkündür; bir zamanlar bizi koruyan bu yollar, artık bizi sınırlıyor olabilir. Ama bu, onların yanlış olduğu anlamına gelmez. Sadece artık aynı koşullarda olmadığımızı gösterir.

İçimizde hala o eski sistemle çalışan bir parça vardır. Ve o parça aslında hala bizi korumaya çalışıyordur.

## Bedenin Dili

Bugün yaşadığınız zorlanmalar sadece zihinsel değildir. Beden de geçmişin izlerini taşır. Kendinize şu soruyu sormak önemli;

• "Şu an hissettiğim şey bana ne anlatmaya çalışıyor?"

Çünkü her duygu bir mesaj taşır. Ve çoğu zaman o mesaj geçmişten gelir.

## İçsel Sesin Dönüşümü

İçinizde şöyle bir ses olabilir;

• "Böyle davranmasaydın olmazdı."
• "Daha güçlü olmalısın."
• "Daha iyi olman gerekiyor."

Ama bu sesi biraz daha yakından dinlediğinizde aslında şunu söylemeye çalıştığını fark edebilirsiniz; 'bir zamanlar böyle davranarak kendini korudun.' Bu farkındalık, değişimin başlangıcıdır.

## Bugün Farklı Seçimler Mümkün

Artık o eski ortamda değilsiniz. Ve bugün yeni yollar deneme şansınız var. Bu, geçmişi silmek değil… Onu anlamak ve üzerine yeni bir şey inşa etmek demektir.

## Bu Çalışmada Neye Odaklanıyoruz?

✨ Kendine şefkat geliştirmek
✨ İçsel ihtiyaçları fark edebilmek
✨ Sağlıklı sınırlar kurabilmek
✨ 'Hayır' diyebilme kapasitesini güçlendirmek
✨ Duygularla temas kurabilmek
✨ Öz bakımın sadece bir lüks değil, bir ihtiyaç olduğunu fark etmek

## Kimler İçin Uygun?

• Kendini sürekli yorgun ve tükenmiş hissedenler
• Başkalarına öncelik verip kendini ihmal edenler
• Sınır koymakta zorlananlar
• İçsel eleştirisi güçlü olanlar
• Kendisiyle daha şefkatli bir ilişki kurmak isteyen herkes…

Kendine ebeveynlik yapmak; kendini düzeltmek değil, kendine eşlik etmektir. Kendinizi değiştirmek zorunda değilsiniz. Ama kendini anlamaya başladığında zaten dönüşüm başlar. Ve belki de ilk kez, kendinle aynı tarafta olmayı öğrenirsin.`,
  },
  {
    id: "kardes-iliskileri",
    title: "Kardeş İlişkileri: Kavgayı Azaltmak, Yakınlığı Desteklemek",
    subtitle: "Rekabet yerine bağ kurabilen kardeşler",
    description:
      "Kardeş ilişkilerindeki çatışma çoğu zaman oyuncak meselesi değildir. Altında duygusal ihtiyaçlar vardır. Birlikte bakalım.",
    icon: "🤝",
    duration: "2 saat",
    audience: "Kardeşli ailelerin ebeveynleri ve çocuklarla çalışan uzmanlar",
    content: `• "Bu benim"
• "Önce ben oynayacağım"
• "Hep onu seviyorsun"
• "Benimle hiç ilgilenmiyorsun"

Bu cümleler aslında sadece bir tartışma değil, çocukların görünmek, duyulmak ve değerli hissetmek için verdikleri bir mesajdır.

## Kardeşlik: Aynı Evde İki Ayrı Dünya

Aynı ailede büyüyen iki çocuk, dışarıdan bakıldığında aynı koşullara sahip gibi görünür. Ama her biri, o ailenin içinde farklı bir deneyim yaşar.

Biri için sevgi yeterliyken, diğeri için eksik hissedilebilir. Biri kendini güçlü hissederken, diğeri geri planda kalmış gibi hissedebilir.

Bu yüzden kardeşler arasındaki çatışmalar çoğu zaman basit bir oyuncak meselesi değildir. Altında duygusal ihtiyaçlar vardır.

## Kavgaların Altında Ne Var?

Çocuklar çoğu zaman şunu söyleyemez;

• "Beni de görmeni istiyorum."
• "Ben de önemliyim."
• "Seni paylaşmak zor geliyor."

Bunun yerine; bağırırlar, itişirler, şikayet ederler ve rekabete girerler. Yani davranışlar, aslında duyguların dışa vurumudur.

## Ebeveyn Olarak En Büyük Tuzak

Çoğu zaman refleksimiz şu olur;

• "Kim haklı?"
• "Kim başlattı?"
• "Hemen çözeyim."

Ama bu yaklaşım, sorunun özünü kaçırabilir. Çünkü mesele kimin haklı olduğu değil, iki çocuğun da ne hissettiğidir.

## Ne Yapıyoruz Bu Süreçte?

Bu eğitimde amacımız sadece kavgayı durdurmak değil, çocukların birbirleriyle gerçek bir bağ kurabilmesini desteklemek.

✨ Kardeşler arasındaki çatışmaların altında yatan duyguları fark etmek
✨ Çocukların kıyaslanmadan, ayrı ayrı görülmesini sağlamak
✨ Tartışma anlarında nasıl sakin ve dengeli kalabileceğimizi öğrenmek
✨ Sürekli müdahale etmek yerine ne zaman geri duracağımızı ayırt etmek
✨ Çocukların kendi ilişkilerini kurmalarına alan açmak
✨ Rekabeti azaltıp iş birliğini desteklemek

## Kıskançlık Normal mi?

Evet. Kıskançlık, kardeş ilişkilerinde oldukça doğal bir duygudur. Ama önemli olan şu; bu duygunun nasıl karşılandığı. Bastırıldığında büyür, görmezden gelindiğinde davranışa dönüşür, anlaşıldığında ise yumuşar.

## Kavga Her Zaman Kötü mü?

Aslında hayır. Doğru şekilde ele alındığında çatışma; sınır koymayı öğretir, kendini ifade etmeyi geliştirir ve empati kurmayı destekler. Yani mesele kavgayı tamamen yok etmek değil, onu sağlıklı bir zemine taşımaktır.

## Hangi Durumlarda Bu Çalışma Size Uygun?

• Çocuklarınız sık sık tartışıyorsa
• Sürekli araya girmek zorunda hissediyorsanız
• Birine daha fazla yükleniyormuş gibi hissediyorsanız
• Evdeki gerginlik sizi yoruyorsa
• Çocuklarınızın birbirine daha yakın olmasını istiyorsanız

## Uzun Vadede Hedefimiz Ne?

Amaç sadece sessiz bir ev değil. Amaç; birbirini anlayabilen, farklılıklarına alan açabilen, rekabet yerine bağ kurabilen ve duygularını ifade edebilen kardeşler yetiştirmek.

Kardeşlik, paylaşmayı öğrenmekten çok daha fazlasıdır. Bu süreçte çocuklar; "Sevilmek için yarışmak zorunda mıyım?" sorusuna cevap ararlar. Ve biz ebeveynler olarak verdiğimiz cevap, onların birbirleriyle kuracağı ilişkiyi şekillendirir.`,
  },
];

export function getTrainingById(id) {
  return trainings.find((t) => t.id === id);
}
